"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PagSeguroPromiseResolve_1 = __importDefault(require("../../pages/paymentBooking/payment/PagSeguro/PagSeguroPromiseResolve"));
const users_1 = require("../../utils/users");
const api_1 = __importDefault(require("../api"));
const Checkout_1 = require("./Checkout");
class PaymentService {
    constructor(formPayment, formSuite) {
        this.formPayment = formPayment;
        this.formSuite = formSuite;
        this.setAuthorization = () => {
            const accessToken = (0, users_1.getAccessToken)();
            if (accessToken && accessToken.trim().length > 0) {
                api_1.default.defaults.headers.authorization = `Bearer ${accessToken}`;
            }
        };
        this.getCouponDetails = (coupon) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api_1.default.post(`/payments/coupon`, coupon);
            return response.data;
        });
        this.sendCouponDetails = (invoice) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api_1.default.put(`/bookings/coupon`, invoice);
            return response.data;
        });
        this.payment = this.formPayment ? this.formPayment.getFieldsValue() : {};
        this.guest = this.formSuite ? this.formSuite.getFieldsValue() : {};
        this.guest.email = (0, users_1.getUserData)().email;
    }
    sendCheckoutPayload(checkoutPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setAuthorization();
            const response = yield api_1.default.post(`/payments/checkout`, checkoutPayload);
            return response.data;
        });
    }
    mountCheckoutCreditPayload(credit, confirmValues) {
        return __awaiter(this, void 0, void 0, function* () {
            return PagSeguroPromiseResolve_1.default.myCreateCardToken(credit)
                .then((card) => {
                return new Checkout_1.Checkout(this.payment, this.guest).CreditPayload(card, confirmValues);
            })
                .catch(err => {
                return err.message;
            });
        });
    }
    mountCheckoutDebitPayload(confirmValues) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Checkout_1.Checkout(this.payment, this.guest).DebitPayload(confirmValues);
        });
    }
    mountCheckoutPixPayload(confirmValues) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Checkout_1.Checkout(this.payment, this.guest).PixPayload(confirmValues);
        });
    }
}
exports.default = PaymentService;
